import { Controller } from "@hotwired/stimulus";
import $ from 'jquery'
import 'bootstrap-select'
$.fn.selectpicker.Constructor.BootstrapVersion = '4';

export default class extends Controller {
  static targets = [
    'filterSelect',
  ]

  connect() {
    console.log('=== FilterSelect controller CONNECT ===');
    this.filterName = this.filterSelectTarget.dataset.filterName
    
    // Force delay for Turbo navigation
    setTimeout(() => {
      this.initializeSelectpicker();
    }, 100);
  }

  disconnect() {
    console.log('FilterSelect controller DISCONNECT');
    
    // Clean up custom event listeners
    $(document).off('click.filter-select');
    
    try {
      const $select = $(this.filterSelectTarget);
      if ($select.data('selectpicker')) {
        // Remove custom events first
        $select.siblings('.dropdown-toggle').off('click.bs.dropdown');
        $select.siblings('.dropdown-menu').off('click.bs.dropdown');
        
        // Destroy selectpicker
        $select.selectpicker('destroy');
      }
      $select.siblings().remove();
    } catch (e) {
      console.log('Disconnect error:', e);
    }
  }

  initializeSelectpicker() {
    console.log('=== INITIALIZING SELECTPICKER ===');
    
    // Force destroy any existing instances
    try {
      if ($(this.filterSelectTarget).data('selectpicker')) {
        console.log('Destroying existing selectpicker');
        $(this.filterSelectTarget).selectpicker('destroy');
      }
    } catch (e) {
      console.log('Destroy error:', e);
    }

    // Create selectpicker
    console.log('Creating new selectpicker...');
    const $select = $(this.filterSelectTarget).selectpicker({
      selectedTextFormat: "count> 2",
      countSelectedText: (count) => `${count} ${this.filterName} selected`,
      liveSearch: true,
      size: 5,
      maxOptions: 5,
      noneSelectedText: `All ${this.filterName}`
    });

    // Force refresh after creation
    setTimeout(() => {
      console.log('Force refreshing selectpicker...');
      $select.selectpicker('refresh');
      
      const dropdown = $select.siblings('.dropdown-menu');
      console.log('Dropdown found:', dropdown.length);
      
      if (dropdown.length > 0) {
        dropdown.append(this.actionBox);
        
        // Add search event listeners
        dropdown.on('click', '.bs-searchbox input', function (e) {
          e.stopPropagation();
        });

        dropdown.on('keydown', '.bs-searchbox input', function (e) {
          e.stopPropagation();
        });
        
        // CRITICAL: Force re-bind bootstrap-select events after Turbo navigation
        this.forceRebindEvents($select);
        
        console.log('=== SelectPicker initialized successfully ===');
      } else {
        console.error('=== NO DROPDOWN MENU FOUND! ===');
      }
    }, 150);
  }

  forceRebindEvents($select) {
    console.log('Force rebinding bootstrap-select events...');
    
    // Get the dropdown button and menu
    const $button = $select.siblings('.dropdown-toggle');
    const $menu = $select.siblings('.dropdown-menu');
    
    // Remove old event listeners
    $button.off('click.bs.dropdown');
    $menu.off('click.bs.dropdown');
    
    // Re-bind click events manually
    $button.on('click.bs.dropdown', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const isOpen = $(this).attr('aria-expanded') === 'true';
      console.log('Button clicked, currently open:', isOpen);
      
      if (isOpen) {
        // Close dropdown
        $(this).attr('aria-expanded', 'false');
        $(this).parent().removeClass('open');
        $menu.removeClass('show');
      } else {
        // Open dropdown
        $(this).attr('aria-expanded', 'true');
        $(this).parent().addClass('open');
        $menu.addClass('show');
      }
    });
    
    // Prevent menu from closing when clicking inside
    $menu.on('click.bs.dropdown', function(e) {
      e.stopPropagation();
    });
    
    // Close dropdown when clicking outside
    $(document).on('click.filter-select', function(e) {
      if (!$select.parent().is(e.target) && $select.parent().has(e.target).length === 0) {
        $button.attr('aria-expanded', 'false');
        $button.parent().removeClass('open');
        $menu.removeClass('show');
      }
    });
    
    console.log('Events rebound successfully');
  }

  get actionBox() {
    return `
        <div class="bs-actionsbox">
          <div class="btn-group btn-group-sm btn-block">
            <button type="button" class="actions-btn bs-deselect-all btn btn-light">
              Clear
            </button>
            <button type="button" class="btn btn-primary"
            data-action='${this.identifier}#filter'>
              Filter
            </button>
          </div>
        </div>
      `
  }

  filter() {
    let value = $(this.filterSelectTarget).val();
    var url = new URL(window.location.href);
    url.searchParams.set(this.filterName, value);
    window.location.replace(url.toString());
  }
}
